export default __webpack_public_path__ + "4948ad430cd1bc279d07f52f05bed6a7.svg";